// =============================================================================
//  Copyright : 2021 semantics GmbH
//  Date      : $Date: 2024-11-15 15:24:38 +0100 (Fri, 15 Nov 2024) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 147542 $
//  Purpose   : qa parts
// =============================================================================
// ---Third-party imports
import React from 'react'

import {loadLazy as ll, funcPart} from 'uix/parts'

// ---Exports

export const TreeStates = ll(() => import(/* webpackChunkName: 'qa' */ './states'))
export const TreeQA = ll(() => import(/* webpackChunkName: 'qa' */ './pageinfo'))
